import { render, staticRenderFns } from "./ProductTagsTable.vue?vue&type=template&id=6f88fa59&scoped=true&"
import script from "./ProductTagsTable.vue?vue&type=script&lang=js&"
export * from "./ProductTagsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f88fa59",
  null
  
)

export default component.exports